import { StatusCode } from '@wwt/api/base/base'

/**
 * Error with server
 *
 * In base it means not correct status of server response, like 500, 502 or 503
 */
export class ServerUnavailableError extends Error {
	status: StatusCode

	constructor(status: StatusCode, message: string) {
		super(message)
		this.name = `Server unavailable`
		this.status = status
	}
}
